import { render, staticRenderFns } from "./registration_norms.vue?vue&type=template&id=794a6147&scoped=true"
import script from "./registration_norms.vue?vue&type=script&lang=js"
export * from "./registration_norms.vue?vue&type=script&lang=js"
import style0 from "./registration_norms.vue?vue&type=style&index=0&id=794a6147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a6147",
  null
  
)

export default component.exports